import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { getFieldPath, useOptionalLabel } from "@shared";
import { FormikValues, getIn } from "formik";

import { FormikCheckboxProps } from "./FormikCheckbox.types";

export function FormikCheckbox<T extends FormikValues>(props: FormikCheckboxProps<T>) {
  const {
    fieldName,
    path,
    label,
    optional,
    formControlProps,
    formControlLabelProps,
    formik,
    onValueChange,
    ...others
  } = props;
  const fullPath = getFieldPath(path, fieldName);
  const resolvedLabel = useOptionalLabel(label, optional);
  return (
    <FormControl margin="none" variant="outlined" {...formControlProps}>
      <FormControlLabel
        {...formControlLabelProps}
        label={resolvedLabel}
        control={
          <Checkbox
            {...others}
            checked={(getIn(formik.values, fullPath) as boolean | undefined) ?? false}
            onChange={(_, checked) => {
              void formik.setFieldValue(fullPath, checked);
              onValueChange?.(checked);
            }}
          />
        }
      />
    </FormControl>
  );
}
